import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect, useDispatch } from 'react-redux'
import { push } from 'react-router-redux'
import {
  isQuestDesigner,
  isInternalReviewer,
  isOeReviewer,
  isQuestCopyEditor,
  isQuestManager
} from '../../utils/user'

export function restrictRole (Component) {
  const RoleRequiredComponent = props => {
    const dispatch = useDispatch()

    const allowAccess = () => {
      const { user, route } = props
      return (
        (route.path === 'quests/add' && isQuestDesigner(user)) ||
        (route.path === 'reviewqueue' &&
          (isInternalReviewer(user) || isOeReviewer(user))) ||
        (route.path.includes('activities/add') &&
          (isQuestDesigner(user) ||
            isQuestCopyEditor(user) ||
            isQuestManager(user)))
      )
    }

    useEffect(() => {
      if (!allowAccess()) {
        dispatch(push('/quests'))
      }
    })

    return (
      <div>
        <Component {...props} />
      </div>
    )
  }

  RoleRequiredComponent.propTypes = {
    user: PropTypes.object,
    route: PropTypes.object.isRequired
  }

  const mapStateToProps = state => ({
    user: state.user.user
  })

  return connect(mapStateToProps)(RoleRequiredComponent)
}



// WEBPACK FOOTER //
// ./src/containers/HOC/RoleRequiredComponent.js